import { render, staticRenderFns } from "./bulkUpdate.vue?vue&type=template&id=323eb13a"
import script from "./bulkUpdate.vue?vue&type=script&lang=js"
export * from "./bulkUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports